export default __webpack_public_path__ + "static/media/liquidDeliveryLearnMore.0e85820d.png";